import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.jsx'
import Quote from './components/Quote.jsx'
import QuoteV2 from './components/QuoteV2.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/quote-v2" element={<QuoteV2 />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
